import React from 'react';
import Calendar from '../../../pages/Calendar';

const AICalendar: React.FC = () => {
  return <Calendar />;
};

export default AICalendar;